// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__p9k8b","no-notes-icon":"styles_no-notes-icon__efe+e"};